class ProductLightingOptionsMobile extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'modal', 'close', 'backdrop']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.trigger.element, 'click', () =>
      this.openModal(),
    )
    this.listeners.add(this.els.backdrop.element, 'click', () =>
      this.closeModal(),
    )
    this.listeners.add(this.els.close.element, 'click', () => this.closeModal())
  }

  closeModal () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('lyt-Header-modalOpen')
    document.body.style.removeProperty('overflow', 'hidden')
  }

  openModal () {
    if (window.innerWidth < 768) {
      this.els?.modal?.element?.setAttribute('aria-hidden', 'false')
      document.body.classList.add('lyt-Header-modalOpen')
      document.body.style.setProperty('overflow', 'hidden')
    }
  }
}

if (!window.customElements.get('product-lighting-options-mobile')) {
  window.customElements.define(
    'product-lighting-options-mobile',
    ProductLightingOptionsMobile,
  )
}
